import { render, staticRenderFns } from "./ResourcePhotoPicker.vue?vue&type=template&id=972b981e&scoped=true&"
import script from "./ResourcePhotoPicker.vue?vue&type=script&lang=ts&"
export * from "./ResourcePhotoPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePhotoPicker.vue?vue&type=style&index=0&id=972b981e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b981e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972b981e')) {
      api.createRecord('972b981e', component.options)
    } else {
      api.reload('972b981e', component.options)
    }
    module.hot.accept("./ResourcePhotoPicker.vue?vue&type=template&id=972b981e&scoped=true&", function () {
      api.rerender('972b981e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourcePhotoPicker.vue"
export default component.exports